import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
    "& .MuiGrid-container": {
      flexWrap: "nowrap",
    },
  },
  editIcon: {
    marginLeft: 12,
  },
  titleContainer: {
    display: "flex",
    justifyItems: "center",
    alignItems: "center",
    marginRight: 10,
    maxWidth: 600,
    [theme.breakpoints.down("lg")]: {
      maxWidth: 450,
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: 250,
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 180,
    },
  },
  title: {
    [theme.breakpoints.down("lg")]: {
      fontSize: 24,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
}));
